# Archived

When a job posting feature has been significantly revised,
its prior documentation is moved to this section and retained for troubleshooting purposes.
